(() => {
  const selectPreviewLetter = (button) => {
    const root = button.closest('[data-bsk-letter-preview]');
    if (!root) return;
    const letter = button.dataset.bskHomeLetter || '';
    root.querySelectorAll('[data-bsk-home-letter]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    root.querySelectorAll('[data-bsk-home-letter-output]').forEach((output) => { output.textContent = letter; });

    const media = root.querySelector('[data-bsk-home-letter-media]');
    const glyph = media?.querySelector('[data-bsk-home-letter-glyph]');
    const imageUrl = button.dataset.bskLetterImage || '';
    if (!media || !glyph) return;

    let image = media.querySelector('[data-bsk-home-letter-image]');
    if (!imageUrl) {
      if (image) image.hidden = true;
      glyph.hidden = false;
      return;
    }

    if (!image) {
      image = document.createElement('img');
      image.className = 'bsk-letter-preview__image';
      image.dataset.bskHomeLetterImage = '';
      image.width = 160;
      image.height = 160;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.prepend(image);
    }
    image.src = imageUrl;
    if (button.dataset.bskLetterImageSrcset) image.srcset = button.dataset.bskLetterImageSrcset;
    else image.removeAttribute('srcset');
    image.sizes = '64px';
    image.alt = button.dataset.bskLetterImageAlt || `${letter} harfli el yapımı kupa yakın çekimi`;
    image.style.objectPosition = button.dataset.bskLetterImagePosition || '50% 50%';
    image.style.setProperty('--bsk-letter-preview-zoom', button.dataset.bskLetterImageZoom || '1.25');
    image.hidden = false;
    glyph.hidden = true;
  };
  document.addEventListener('click', (event) => {
    const giftPackage = event.target.closest('.bsk-gift-package:not(.bsk-gift-package--none)');
    if (!giftPackage) return;

    const input = giftPackage.querySelector('input[type="radio"]');
    if (!input) return;
    if (event.target === input) return;

    event.preventDefault();
    event.stopPropagation();

    const shouldSelect = !input.checked;
    const productRoot = giftPackage.closest('[data-bsk-product]') || document;
    productRoot.querySelectorAll('input[type="radio"]').forEach((candidate) => {
      if (candidate.name === input.name) candidate.checked = false;
    });

    input.checked = shouldSelect;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-bsk-quantity-minus], [data-bsk-quantity-plus]');
    if (!control) return;

    const productRoot = control.closest('[data-bsk-product]');
    const input = productRoot?.querySelector('[data-bsk-quantity-input]');
    if (!input) return;

    const current = Math.max(1, Number.parseInt(input.value, 10) || 1);
    input.value = control.hasAttribute('data-bsk-quantity-plus') ? current + 1 : Math.max(1, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('click', (event) => {
    const letterButton = event.target.closest('[data-bsk-home-letter]');
    if (letterButton) selectPreviewLetter(letterButton);
  });
  document.addEventListener('shopify:section:load', (event) => {
    const first = event.target.querySelector('[data-bsk-home-letter][aria-pressed="true"]');
    if (first) selectPreviewLetter(first);
  });
  document.addEventListener('click', (event) => {
    const openFilters = event.target.closest('[data-bsk-open-filters]');
    if (openFilters) {
      const main = openFilters.closest('.bsk-collection');
      const dialog = main && main.querySelector('[data-bsk-filter-dialog]');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    const closeFilters = event.target.closest('[data-bsk-close-filters]');
    if (closeFilters) {
      const dialog = closeFilters.closest('[data-bsk-filter-dialog]');
      if (dialog) dialog.close();
    }
  });
  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-bsk-filter-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });
  const formatMoney = (cents, currency) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency }).format(Number(cents) / 100); }
    catch (_) { return (Number(cents) / 100).toFixed(2) + ' ' + currency; }
  };
  const cartEndpoint = (suffix = '') => {
    const base = (window.routes?.cart_url || '/cart').replace(/\/$/, '');
    return suffix ? base + suffix : base;
  };
  const cartDrawer = {
    root: null,
    panel: null,
    cart: null,
    groups: [],
    opener: null,
    busy: false
  };
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);
  const visibleProperties = (item) => Object.entries(item.properties || {}).filter(([key, value]) => value && !key.startsWith('_'));
  const addonIdentity = (item) => [item.variant_id, JSON.stringify(visibleProperties(item))].join(':');
  const readBundleMeta = (item) => {
    const properties = item?.properties || {};
    const compactRef = String(properties._bsk_ref || '');

    if (compactRef) {
      const [bundleId, type] = compactRef.split(':');
      return {
        bundleId,
        isAddon: type === 'A'
      };
    }

    return {
      bundleId: properties._bsk_bundle_id,
      isAddon: properties._bsk_addon === 'true'
    };
  };

  const buildCartGroups = (cart) => {
    const groups = [];
    const bundleGroups = new Map();
    (cart.items || []).forEach((item) => {
      const { bundleId, isAddon } = readBundleMeta(item);
      let group;
      if (bundleId) {
        group = bundleGroups.get(bundleId);
        if (!group) {
          group = { id: `bundle:${bundleId}`, bundleId, items: [], parents: [], addons: [] };
          bundleGroups.set(bundleId, group);
          groups.push(group);
        }
      } else {
        group = { id: `line:${item.key}`, bundleId: '', items: [], parents: [], addons: [] };
        groups.push(group);
      }
      group.items.push(item);
      (isAddon ? group.addons : group.parents).push(item);
    });
    return groups.map((group) => {
      const lead = group.parents[0] || group.items[0];
      group.lead = lead;
      group.quantity = group.parents.reduce((total, item) => total + item.quantity, 0) || lead?.quantity || 0;
      group.original = group.items.reduce((total, item) => total + Number(item.original_line_price || item.line_price || 0), 0);
      group.final = group.items.reduce((total, item) => total + Number(item.final_line_price ?? item.line_price ?? 0), 0);
      return group;
    });
  };
  const normalizeGiftPairCapacity = (item) => {
    const properties = item?.properties || {};
    let value = String(properties._bsk_capacity || '').trim();
    if (!value && item?.variant_title && item.variant_title !== 'Default Title') {
      value = item.variant_title.match(/\d+(?:[.,]\d+)?\s*(?:ml|cl|l)\b/i)?.[0] || '';
    }
    return value.toLocaleLowerCase('tr-TR').replace(',', '.').replace(/\s+/g, ' ').trim();
  };
  const hasPremiumDoublePackage = (item) => Object.entries(item?.properties || {}).some(([key, value]) => {
    const normalizedKey = String(key).toLocaleLowerCase('tr-TR');
    const normalizedValue = String(value).toLocaleLowerCase('tr-TR');
    return normalizedKey.includes('hediye paketi') && /premium\s*(?:ikili|2)|ikili\s*premium/.test(normalizedValue);
  });
  const premiumDoubleGroup = (groups) => groups.find((group) => group.parents.some(hasPremiumDoublePackage));
  const isPremiumDoubleAddon = (item, root) => {
    const configuredVariantId = Number(root?.dataset.bskPremiumDoubleVariantId || 0);
    if (configuredVariantId && Number(item.variant_id) === configuredVariantId) return true;
    const identity = [item.handle, item.product_title, item.title, item.sku].filter(Boolean).join(' ').toLocaleLowerCase('tr-TR');
    return /premium\s*(?:ikili|2)|premium2|pre2/.test(identity);
  };
  const validatePremiumGiftPair = (cart, groups) => {
    const hasPremiumDouble = groups.some((group) => group.parents.some(hasPremiumDoublePackage));
    if (!hasPremiumDouble) return { state: 'none', blocking: false };

    const products = [];
    groups.forEach((group) => group.parents.forEach((item) => {
      const quantity = Math.max(0, Number(item.quantity || 0));
      const capacity = normalizeGiftPairCapacity(item);
      for (let index = 0; index < quantity; index += 1) products.push({ capacity });
    }));

    if (products.length < 2) {
      return {
        state: 'single',
        blocking: true,
        title: 'Premium İkili kutu için 1 fincan daha gerekiyor',
        message: 'Kutu aynı boyda iki fincan için hazırlanır. Aynı hacimde bir fincan daha ekleyin veya paket seçimini değiştirin.'
      };
    }

    const capacities = products.map((product) => product.capacity).filter(Boolean);
    if (products.length === 2 && capacities.length === 2 && capacities[0] !== capacities[1]) {
      return {
        state: 'mismatch',
        blocking: true,
        title: 'Seçtiğiniz fincanların boyları farklı',
        message: 'Premium İkili kutuda iki fincan aynı boyda olmalıdır. Aynı hacimde iki fincan seçin veya paket seçimini değiştirin.'
      };
    }

    if (products.length > 2 && capacities.length === products.length) {
      const capacityCounts = capacities.reduce((counts, capacity) => counts.set(capacity, (counts.get(capacity) || 0) + 1), new Map());
      const hasMatchingPair = Array.from(capacityCounts.values()).some((count) => count >= 2);
      if (!hasMatchingPair) {
        return {
          state: 'mismatch',
          blocking: true,
          title: 'Aynı boyda iki fincan bulunamadı',
          message: 'Premium İkili kutu için aynı hacimde en az iki fincan seçin veya paket seçimini değiştirin.'
        };
      }
    }

    return { state: 'valid', blocking: false };
  };
  const renderPremiumGiftPairValidation = (cart) => {
    const root = drawerElements();
    const alert = root?.querySelector('[data-bsk-gift-pair-alert]');
    const checkoutForm = root?.querySelector('[data-bsk-cart-checkout-form]');
    if (!root || !alert || !checkoutForm) return { state: 'none', blocking: false };
    const validation = validatePremiumGiftPair(cart, cartDrawer.groups);
    const pairGroup = premiumDoubleGroup(cartDrawer.groups);
    const downgradeButton = alert.querySelector('[data-bsk-gift-pair-downgrade]');
    const canDowngrade = Boolean(
      validation.blocking &&
      pairGroup?.bundleId &&
      Number(root.dataset.bskPremiumSingleVariantId || 0) &&
      pairGroup.addons.some((item) => isPremiumDoubleAddon(item, root))
    );
    alert.hidden = !validation.blocking;
    alert.dataset.bskGiftPairState = validation.state;
    checkoutForm.dataset.bskGiftPairBlocked = String(validation.blocking);
    if (downgradeButton) {
      downgradeButton.hidden = !canDowngrade;
      downgradeButton.dataset.bskGiftBundleId = canDowngrade ? pairGroup.bundleId : '';
    }
    if (validation.blocking) {
      alert.querySelector('[data-bsk-gift-pair-title]').textContent = validation.title;
      alert.querySelector('[data-bsk-gift-pair-message]').textContent = validation.message;
      checkoutForm.querySelector('[type="submit"]')?.setAttribute('aria-describedby', alert.id || '');
    } else {
      checkoutForm.querySelector('[type="submit"]')?.removeAttribute('aria-describedby');
    }
    return validation;
  };
  const drawerElements = () => {
    if (!cartDrawer.root) cartDrawer.root = document.querySelector('[data-bsk-cart-drawer]');
    if (!cartDrawer.panel) cartDrawer.panel = cartDrawer.root?.querySelector('[data-bsk-cart-panel]');
    return cartDrawer.root;
  };
  const setCartCount = (count) => {
    document.querySelectorAll('[data-bsk-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
    document.querySelectorAll('[data-bsk-cart-heading-count]').forEach((node) => { node.textContent = count; });
  };
  const setDrawerBusy = (busy) => {
    cartDrawer.busy = busy;
    const root = drawerElements();
    if (!root) return;
    root.classList.toggle('is-busy', busy);
    root.querySelectorAll('button, textarea').forEach((control) => { control.disabled = busy; });
    window.BskSecondCupOffer?.syncCheckout();
  };
  const announceDrawer = (message) => {
    const live = drawerElements()?.querySelector('[data-bsk-cart-live]');
    if (live) live.textContent = message;
  };
  const renderDrawerCart = (cart) => {
    const root = drawerElements();
    if (!root) return;
    cart = window.BskSecondCupOffer?.priceCart(cart) || cart;
    cartDrawer.cart = cart;
    cartDrawer.groups = buildCartGroups(cart);
    const currency = cart.currency || root.dataset.currency || 'TRY';
    const logicalCount = cartDrawer.groups.reduce((total, group) => total + group.quantity, 0);
    const originalTotal = Number(cart.original_total_price || cart.items.reduce((total, item) => total + Number(item.original_line_price || 0), 0));
    const finalTotal = Number(cart.total_price || 0);
    const savings = Math.max(0, originalTotal - finalTotal);
    const threshold = Number(root.dataset.freeShippingThreshold || 0);
    const remaining = Math.max(0, threshold - finalTotal);
    const progress = threshold > 0 ? Math.min(100, (finalTotal / threshold) * 100) : 100;
    const items = root.querySelector('[data-bsk-cart-items]');
    const empty = root.querySelector('[data-bsk-cart-empty]');
    const footer = root.querySelector('[data-bsk-cart-footer]');
    const loading = root.querySelector('[data-bsk-cart-loading]');
    const error = root.querySelector('[data-bsk-cart-error]');
    if (loading) loading.hidden = true;
    if (error) error.hidden = true;
    setCartCount(logicalCount);
    root.querySelectorAll('[data-bsk-cart-subtotal]').forEach((node) => { node.textContent = formatMoney(finalTotal, currency); });
    root.querySelectorAll('[data-bsk-cart-savings]').forEach((node) => {
      node.closest('[data-bsk-cart-savings-row]').hidden = savings <= 0;
      node.textContent = `-${formatMoney(savings, currency)}`;
    });
    const shippingText = root.querySelector('[data-bsk-cart-shipping-text]');
    const shippingBar = root.querySelector('[data-bsk-cart-shipping-bar]');
    const shipping = root.querySelector('[data-bsk-cart-shipping]');
    if (shipping) shipping.hidden = logicalCount === 0;
    if (shippingText) shippingText.innerHTML = threshold <= 0
      ? '<strong>Türkiye içi tüm siparişlerde kargo ücretsiz.</strong>'
      : remaining > 0
        ? `<strong>${escapeHtml(formatMoney(remaining, currency))}</strong> daha ekle, kargo bizden.`
        : '<strong>Ücretsiz kargoyu kazandın.</strong>';
    if (shippingBar) {
      shippingBar.hidden = threshold <= 0;
      shippingBar.style.setProperty('--bsk-cart-progress', `${progress}%`);
    }
    if (empty) empty.hidden = logicalCount > 0;
    if (footer) footer.hidden = logicalCount === 0;
    renderPremiumGiftPairValidation(cart);
    if (!items) return;
    items.hidden = logicalCount === 0;
    const secondCupProducts = new Set();
    items.innerHTML = cartDrawer.groups.map((group) => {
      const item = group.lead;
      const imageUrl = item.featured_image?.url || item.image || '';
      const productUrl = item.url || '#';
      const properties = visibleProperties(item).filter(([key]) => !['Ek özellik', 'Ekstra Özellikler'].includes(key));
      const propertiesMarkup = properties.length ? `<ul class="bsk-cdrawer__properties">${properties.map(([key, value]) => `<li><span>${escapeHtml(key)}:</span> ${escapeHtml(value)}</li>`).join('')}</ul>` : '';
      const addonsMarkup = group.addons.length ? `<div class="bsk-cdrawer__addons"><span class="bsk-cdrawer__addons-title">Seçimlerin</span>${group.addons.map((addon) => {
        const label = visibleProperties(addon).find(([key]) => key === 'Ek özellik')?.[1] || addon.product_title || addon.title;
        const price = Number(addon.final_line_price ?? addon.line_price ?? 0);
        return `<div><span>${escapeHtml(label)}</span><strong>+${escapeHtml(formatMoney(price, currency))}</strong></div>`;
      }).join('')}</div>` : '';
      const compareMarkup = group.original > group.final ? `<s>${escapeHtml(formatMoney(group.original, currency))}</s>` : '';
      const offerLabel = window.BskSecondCupOffer?.lineLabel(item) || '';
      const discountedOffer = window.BskSecondCupOffer?.isOfferItem(item);
      const hasLetter = visibleProperties(item).some(([key]) => key.trim().toLocaleLowerCase('tr-TR') === 'harf')
        || (item.options_with_values || []).some((option) => String(option.name).toLocaleLowerCase('tr-TR') === 'harf');
      const cupTitle = String(item.product_title || item.title || '').toLocaleLowerCase('tr-TR');
      const discountAvailable = Boolean(window.BskSecondCupOffer?.canOffer(item, cart));
      const offerSecondCup = (hasLetter || discountAvailable) && /fincan|kupa/.test(cupTitle) && !/takım|seti|ikili/.test(cupTitle) && !secondCupProducts.has(item.product_id);
      if (offerSecondCup) secondCupProducts.add(item.product_id);
      return `<article class="bsk-cdrawer__item" data-bsk-cart-group="${escapeHtml(group.id)}">
        <a class="bsk-cdrawer__image" href="${escapeHtml(productUrl)}" aria-label="${escapeHtml(item.product_title || item.title)}">${imageUrl ? `<img src="${escapeHtml(imageUrl)}&width=240" alt="${escapeHtml(item.featured_image?.alt || item.product_title || '')}" width="120" height="120" loading="lazy">` : ''}</a>
        <div class="bsk-cdrawer__item-content">
          <div class="bsk-cdrawer__item-head"><a href="${escapeHtml(productUrl)}">${escapeHtml(item.product_title || item.title)}</a><button type="button" class="bsk-cdrawer__remove" data-bsk-cart-remove="${escapeHtml(group.id)}" aria-label="${escapeHtml(item.product_title || item.title)} ürününü kaldır">Kaldır</button></div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="bsk-cdrawer__variant">${escapeHtml(item.variant_title)}</p>` : ''}
          ${propertiesMarkup}${offerLabel ? `<p class="bsk-offer-line-note">${escapeHtml(offerLabel)}</p>` : ''}${addonsMarkup}
          <div class="bsk-cdrawer__item-foot">
            ${discountedOffer ? `<span class="bsk-offer-line-quantity">${group.quantity} adet</span>` : `<div class="bsk-cdrawer__quantity" aria-label="Adet seçimi"><button type="button" data-bsk-cart-quantity="${escapeHtml(group.id)}" data-delta="-1" aria-label="Adedi azalt">−</button><span aria-live="polite">${group.quantity}</span><button type="button" data-bsk-cart-quantity="${escapeHtml(group.id)}" data-delta="1" aria-label="Adedi artır">+</button></div>`}
            <div class="bsk-cdrawer__line-price">${compareMarkup}<strong>${escapeHtml(formatMoney(group.final, currency))}</strong></div>
          </div>
          ${offerSecondCup ? `<button type="button" class="bsk-cdrawer__second-button" data-bsk-second-open="${escapeHtml(group.id)}">${discountAvailable ? hasLetter ? 'İkinci fincanın harfini seç' : 'İkinci fincanını ekle' : 'Bir fincan daha ekle'} <span aria-hidden="true">→</span><small>${discountAvailable ? 'İkilinin uygun fiyatlı ürününe %20 indirim.' : hasLetter ? 'Yeni fincanın harfini ayrı seç.' : 'Aynı modelden ikinci ürününü ekle.'}</small></button>` : ''}
        </div>
      </article>`;
    }).join('');
    const note = root.querySelector('[data-bsk-cart-note]');
    if (note && document.activeElement !== note) note.value = cart.note || '';
    window.BskOfferJourney?.cartChanged(cart);
    void loadDrawerRecommendations(cart);
  };
  const loadDrawerRecommendations = async (cart) => {
    const root = drawerElements();
    const shell = root?.querySelector('[data-bsk-cart-recommendations]');
    const content = shell?.querySelector('[data-bsk-cart-recommendations-content]');
    if (!root || !shell || !content) return;

    const lead = (cart.items || [])
      .filter((item) => !readBundleMeta(item).isAddon)
      .sort((left, right) => Number(right.final_price ?? right.price ?? 0) - Number(left.final_price ?? left.price ?? 0))[0];
    if (!lead || !root.dataset.recommendationsUrl) {
      shell.hidden = true;
      content.replaceChildren();
      delete shell.dataset.bskLoadedKey;
      delete shell.dataset.bskRequestKey;
      shell.removeAttribute('aria-busy');
      return;
    }

    const cartProductIds = new Set((cart.items || []).map((item) => String(item.product_id)));
    const requestKey = `${lead.product_id}:${Array.from(cartProductIds).sort().join(',')}`;
    if (shell.dataset.bskLoadedKey === requestKey) return;
    shell.dataset.bskRequestKey = requestKey;
    shell.hidden = true;
    shell.setAttribute('aria-busy', 'true');

    const limit = Math.max(1, Number(root.dataset.recommendationsLimit || 3));
    const fetchCards = async () => {
      try {
        const url = new URL(root.dataset.recommendationsUrl, window.location.origin);
        url.searchParams.set('section_id', root.dataset.recommendationsSectionId || 'bsk-cart-drawer');
        url.searchParams.set('product_id', lead.product_id);
        url.searchParams.set('limit', Math.max(6, limit * 2));
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) return [];
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = documentFragment.querySelector('[data-bsk-cart-recommendations-content]');
        if (!source) return [];
        return Array.from(source.querySelectorAll('[data-bsk-recommendation-card]')).filter((card) => !cartProductIds.has(card.dataset.bskRecommendationProductId));
      } catch (_) { return []; }
    };

    let cards = await fetchCards();
    if (shell.dataset.bskRequestKey !== requestKey) return;
    cards = cards.slice(0, limit);
    content.replaceChildren(...cards);
    shell.hidden = cards.length === 0;
    shell.dataset.bskLoadedKey = requestKey;
    shell.removeAttribute('aria-busy');
  };
  const loadDrawerCart = async () => {
    const root = drawerElements();
    if (!root) return null;
    root.querySelector('[data-bsk-cart-loading]').hidden = false;
    root.querySelector('[data-bsk-cart-error]').hidden = true;
    try {
      const response = await fetch(cartEndpoint('.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Sepet alınamadı');
      const cart = await response.json();
      const pricedCart = await (window.BskSecondCupOffer?.syncCart(cart) || cart);
      renderDrawerCart(pricedCart);
      return pricedCart;
    } catch (_) {
      root.querySelector('[data-bsk-cart-loading]').hidden = true;
      root.querySelector('[data-bsk-cart-error]').hidden = false;
      return null;
    }
  };
  const openCartDrawer = async (opener) => {
    const root = drawerElements();
    if (!root) {
      window.location.assign(cartEndpoint());
      return;
    }
    cartDrawer.opener = opener || document.activeElement;
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('is-open');
    document.documentElement.classList.add('bsk-cart-open', 'bsk-cart-ready');
    document.querySelectorAll('[data-bsk-cart-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
    await loadDrawerCart();
    requestAnimationFrame(() => root.querySelector('[data-bsk-cart-close]')?.focus());
  };
  const closeCartDrawer = () => {
    const root = drawerElements();
    if (!root) return;
    closeSecondCup(false);
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bsk-cart-open');
    document.querySelectorAll('[data-bsk-cart-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    if (document.body.classList.contains('template-cart')) {
      window.location.assign(window.Shopify?.routes?.root || '/');
      return;
    }
    cartDrawer.opener?.focus?.();
  };
  const postCartUpdate = async (updates) => {
    setDrawerBusy(true);
    try {
      const response = await fetch(cartEndpoint('/update.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Sepet güncellenemedi');
      const cart = await response.json();
      renderDrawerCart(await (window.BskSecondCupOffer?.syncCart(cart) || cart));
      announceDrawer('Sepet güncellendi.');
    } catch (_) {
      announceDrawer('Sepet güncellenemedi. Lütfen tekrar deneyin.');
      await loadDrawerCart();
    } finally { setDrawerBusy(false); }
  };
  const postCartJson = async (suffix, payload) => {
    const response = await fetch(cartEndpoint(suffix), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Sepet güncellenemedi');
    return response.json();
  };
  const fetchCartJson = async () => {
    const response = await fetch(cartEndpoint('.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Sepet alınamadı');
    return response.json();
  };
  const rollbackGiftPackageChange = async ({ bundleId, oldProperties, oldDoubleAddon, singleVariantId }) => {
    try {
      let cart = await fetchCartJson();
      let groups = buildCartGroups(cart);
      let group = groups.find((candidate) => candidate.bundleId === bundleId);
      const parent = group?.parents[0];
      if (parent) {
        cart = await postCartJson('/change.js', { id: parent.key, quantity: parent.quantity, properties: oldProperties });
        groups = buildCartGroups(cart);
        group = groups.find((candidate) => candidate.bundleId === bundleId);
      }
      const singleUpdates = {};
      (group?.addons || []).forEach((item) => {
        if (Number(item.variant_id) === singleVariantId) singleUpdates[item.key] = 0;
      });
      if (Object.keys(singleUpdates).length) cart = await postCartJson('/update.js', { updates: singleUpdates });
      const restoredGroup = buildCartGroups(cart).find((candidate) => candidate.bundleId === bundleId);
      const doubleStillExists = restoredGroup?.addons.some((item) => Number(item.variant_id) === Number(oldDoubleAddon.variant_id));
      if (!doubleStillExists) {
        await postCartJson('/add.js', { items: [{
          id: Number(oldDoubleAddon.variant_id),
          quantity: Number(oldDoubleAddon.quantity || 1),
          properties: { ...(oldDoubleAddon.properties || {}) }
        }] });
      }
    } catch (_) { /* The final cart reload surfaces the current recoverable state. */ }
  };
  const downgradePremiumGiftPackage = async (bundleId, button) => {
    const root = drawerElements();
    const group = cartDrawer.groups.find((candidate) => candidate.bundleId === bundleId);
    const parent = group?.parents[0];
    const oldDoubleAddon = group?.addons.find((item) => isPremiumDoubleAddon(item, root));
    const singleVariantId = Number(root?.dataset.bskPremiumSingleVariantId || 0);
    if (!root || !group || !parent || !oldDoubleAddon || !singleVariantId || cartDrawer.busy) return;

    const oldProperties = { ...(parent.properties || {}) };
    const nextProperties = { ...oldProperties, 'Hediye Paketi': root.dataset.bskPremiumSingleLabel || 'Premium Tekli' };
    const originalLabel = button.textContent;
    setDrawerBusy(true);
    button.textContent = 'Paket güncelleniyor…';
    try {
      await postCartJson('/change.js', { id: parent.key, quantity: parent.quantity, properties: nextProperties });
      await postCartJson('/add.js', { items: [{
        id: singleVariantId,
        quantity: parent.quantity,
        properties: { _bsk_ref: `${bundleId}:A` }
      }] });
      const updates = {};
      group.addons.filter((item) => isPremiumDoubleAddon(item, root)).forEach((item) => { updates[item.key] = 0; });
      const cart = await postCartJson('/update.js', { updates });
      renderDrawerCart(await (window.BskSecondCupOffer?.syncCart(cart) || cart));
      announceDrawer('Hediye paketi Premium Tekli olarak güncellendi.');
    } catch (_) {
      await rollbackGiftPackageChange({ bundleId, oldProperties, oldDoubleAddon, singleVariantId });
      announceDrawer('Hediye paketi güncellenemedi. Sepetin korundu; lütfen tekrar deneyin.');
      await loadDrawerCart();
    } finally {
      button.textContent = originalLabel;
      setDrawerBusy(false);
    }
  };
  const quantityUpdatesForGroup = (group, quantity) => {
    const updates = {};
    if (!group) return updates;
    const parents = group.parents.length ? group.parents : group.items;
    parents.forEach((item, index) => { updates[item.key] = index === 0 ? quantity : 0; });
    const addonSets = new Map();
    group.addons.forEach((item) => {
      const identity = addonIdentity(item);
      if (!addonSets.has(identity)) addonSets.set(identity, []);
      addonSets.get(identity).push(item);
    });
    addonSets.forEach((items) => items.forEach((item, index) => { updates[item.key] = index === 0 ? quantity : 0; }));
    return updates;
  };
  const closeSecondCup = (restoreFocus = true) => {
    const root = drawerElements();
    cartDrawer.secondRequest?.abort();
    cartDrawer.secondRequest = null;
    root?.classList.remove('is-configuring');
    const shell = root?.querySelector('[data-bsk-second-cup]');
    if (shell) shell.hidden = true;
    const content = root?.querySelector('[data-bsk-second-content]');
    if (content) { content.replaceChildren(); content.removeAttribute('aria-busy'); }
    if (restoreFocus) {
      const opener = cartDrawer.secondOpener;
      (opener?.isConnected ? opener : root?.querySelector('[data-bsk-cart-close]'))?.focus();
    }
    cartDrawer.secondOpener = null;
  };
  const openSecondCup = async (groupId, opener, externalContent = null, selection = null) => {
    const root = drawerElements();
    const group = cartDrawer.groups.find((candidate) => candidate.id === groupId);
    const shell = root?.querySelector('[data-bsk-second-cup]');
    const content = externalContent || shell?.querySelector('[data-bsk-second-content]');
    if (!root || !group || !content || cartDrawer.busy) return;
    closeSecondCup(false);
    cartDrawer.secondOpener = opener;
    const controller = new AbortController();
    cartDrawer.secondRequest = controller;
    if (!externalContent) {
      root.classList.add('is-configuring');
      shell.hidden = false;
    }
    content.setAttribute('aria-busy', 'true');
    content.innerHTML = '<p class="bsk-second-cup__loading" role="status">Fincanın seçenekleri yükleniyor…</p>';
    if (!externalContent) {
      root.querySelector('.bsk-cdrawer__body').scrollTop = 0;
      shell.querySelector('h3').focus();
    }
    try {
      const url = new URL(selection?.url || group.lead.url, window.location.origin);
      if (url.origin !== window.location.origin) throw new Error('Ürün bağlantısı geçersiz.');
      url.hash = '';
      url.searchParams.set('variant', String(selection?.variant_id || group.lead.variant_id));
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Ürün seçenekleri yüklenemedi.');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller.signal.aborted) return;
      const source = doc.querySelector('[data-bsk-product]');
      const sourceForm = source?.querySelector('[data-bsk-product-form]');
      const variants = source?.querySelector('[data-bsk-product-variants]');
      if (!sourceForm || !variants || source.dataset.bskPdpProfile === 'helper') throw new Error('Bu fincanın seçeneklerini ürün sayfasından belirleyebilirsin.');
      const productRoot = document.createElement('div');
      productRoot.className = 'bsk-second-cup__options';
      Object.entries(source.dataset).forEach(([key, value]) => { productRoot.dataset[key] = value; });
      productRoot.dataset.bskSecondProduct = '';
      productRoot.dataset.addLabel = 'Bu fincanı sepete ekle';
      productRoot.dataset.letterCtaLabel = 'Yeni fincanın harfini seç';
      const form = document.importNode(sourceForm, true);
      form.querySelectorAll('script, .shopify-payment-button, .bsk-product__payment-terms, shopify-payment-terms').forEach((element) => element.remove());
      const prefix = `bsk-second-${Date.now().toString(36)}-`;
      const idMap = new Map();
      [form, ...form.querySelectorAll('[id]')].forEach((element) => {
        if (!element.id) return;
        idMap.set(element.id, prefix + element.id);
        element.id = prefix + element.id;
      });
      form.querySelectorAll('[for], [aria-controls], [aria-describedby], [aria-labelledby], [form]').forEach((element) => {
        ['for', 'aria-controls', 'aria-describedby', 'aria-labelledby', 'form'].forEach((attribute) => {
          if (!element.hasAttribute(attribute)) return;
          element.setAttribute(attribute, element.getAttribute(attribute).split(/\s+/).map((id) => idMap.get(id) || id).join(' '));
        });
      });
      form.querySelectorAll('input[type="radio"]').forEach((input) => {
        if (!input.name.startsWith('properties[')) input.name = prefix + input.name;
        input.checked = false;
      });
      form.querySelectorAll('input[type="checkbox"]').forEach((input) => { input.checked = false; });
      form.querySelectorAll('textarea, input[type="text"], [data-bsk-letter-input]').forEach((input) => { input.value = ''; });
      const originalProperties = !selection || String(selection.id) === String(group.lead.product_id) ? group.lead.properties || {} : {};
      form.querySelectorAll('input[type="radio"]').forEach((input) => {
        if (!input.name.startsWith('properties[') || input.hasAttribute('data-bsk-addon-variant-id')) return;
        const property = input.name.slice(11, -1);
        if (property.toLocaleLowerCase('tr-TR') !== 'harf') input.checked = String(originalProperties[property] || '') === input.value;
      });
      const originalCharms = String(originalProperties.Charm || '').split(',').map((value) => value.trim());
      form.querySelectorAll('[data-bsk-charm-choice]').forEach((input) => { input.checked = originalCharms.includes(input.value); });
      form.querySelectorAll('input[name^="properties[_bsk_ref"], input[name^="properties[_bsk_bundle"]').forEach((input) => input.remove());
      const none = form.querySelector('.bsk-gift-package--none input');
      if (none) none.checked = true;
      const quantity = form.querySelector('[name="quantity"]');
      if (quantity) quantity.value = '1';
      const image = group.lead.featured_image?.url || group.lead.image;
      const originalLetter = visibleProperties(group.lead).find(([key]) => key.trim().toLocaleLowerCase('tr-TR') === 'harf')?.[1]
        || (group.lead.options_with_values || []).find((option) => String(option.name).toLocaleLowerCase('tr-TR') === 'harf')?.value;
      const summary = document.createElement('div');
      summary.className = 'bsk-second-cup__product';
      summary.innerHTML = `${image ? `<img src="${escapeHtml(image)}" alt="" width="64" height="64">` : '<span></span>'}<span><strong>${escapeHtml(group.lead.product_title || group.lead.title)}</strong><small>${originalLetter ? `Sepetindeki fincan: ${escapeHtml(originalLetter)} harfi.` : 'Sepetindeki fincan korunur.'} Yeni fincan için seçim yap.</small></span>`;
      productRoot.append(summary, form, document.importNode(variants, true));
      content.replaceChildren(productRoot);
      updateProductVariant(productRoot);
      clearLetterSelection(productRoot);
      updatePlateNameField(productRoot);
      updateProfileChoices(productRoot);
      updateAddonTotal(productRoot);
      form.querySelectorAll('[data-bsk-product-message]').forEach((message) => { message.textContent = productRoot.dataset.bskRequiresLetter === 'true' ? 'Bu fincanın harfini seç. Harf fiyata dahildir.' : 'Seçtiğin ikinci ürünü ekleyebilirsin. İlk ürününün seçimleri korunur.'; });
      announceDrawer('Yeni fincanın seçenekleri hazır. İlk fincanın değişmedi.');
      return productRoot;
    } catch (error) {
      if (controller.signal.aborted) return;
      if (externalContent) throw error;
      content.innerHTML = `<div class="bsk-second-cup__error" role="alert"><p>${escapeHtml(error.message || 'Seçenekler yüklenemedi.')}</p><button type="button" class="bsk-cdrawer__second-button" data-bsk-second-open="${escapeHtml(groupId)}">Tekrar dene</button><a href="${escapeHtml(group.lead.url)}">Ürün sayfasından seçim yap</a></div>`;
    } finally {
      if (!controller.signal.aborted) content.removeAttribute('aria-busy');
    }
  };
  const secondCupOfferContext = () => ({
    loadCart: loadDrawerCart,
    getGroups: () => cartDrawer.groups,
    loadProduct: openSecondCup,
    cancelLoad: () => closeSecondCup(false),
    openCart: openCartDrawer,
    closeCart: closeCartDrawer,
    getCart: () => cartDrawer.cart
  });
  const secondCupOfferPreview = ['127.0.0.1', 'localhost', '[::1]'].includes(location.hostname)
    || drawerElements()?.dataset.bskOfferPreview === 'true';
  if (secondCupOfferPreview) window.BskLocalOfferCart = secondCupOfferContext();
  const initializeCartDrawer = () => {
    const root = drawerElements();
    if (!root || root.dataset.bskInitialized === 'true') return;
    root.dataset.bskInitialized = 'true';
    document.documentElement.classList.add('bsk-cart-ready');
    const checkoutForm = root.querySelector('[data-bsk-cart-checkout-form]');
    if (checkoutForm) checkoutForm.addEventListener('submit', (event) => {
      const validation = validatePremiumGiftPair(cartDrawer.cart || { items: [] }, cartDrawer.groups);
      if (!validation.blocking) return;
      event.preventDefault();
      const alert = root.querySelector('[data-bsk-gift-pair-alert]');
      if (alert) {
        alert.hidden = false;
        alert.focus();
      }
      announceDrawer(validation.title || 'Hediye paketi seçimini kontrol edin.');
    });
    root.addEventListener('click', async (event) => {
      if (event.target.closest('[data-bsk-cart-close], [data-bsk-cart-backdrop]')) { closeCartDrawer(); return; }
      if (event.target.closest('[data-bsk-second-back]')) { closeSecondCup(); return; }
      const secondCupButton = event.target.closest('[data-bsk-second-open]');
      if (secondCupButton) {
        if (await window.BskSecondCupOffer?.fromDrawer(secondCupOfferContext(), secondCupButton.dataset.bskSecondOpen, secondCupButton)) return;
        await openSecondCup(secondCupButton.dataset.bskSecondOpen, secondCupButton);
        return;
      }
      if (event.target.closest('[data-bsk-cart-retry]')) { await loadDrawerCart(); return; }
      const downgradeButton = event.target.closest('[data-bsk-gift-pair-downgrade]');
      if (downgradeButton && !cartDrawer.busy) {
        await downgradePremiumGiftPackage(downgradeButton.dataset.bskGiftBundleId, downgradeButton);
        return;
      }
      const quantityButton = event.target.closest('[data-bsk-cart-quantity]');
      if (quantityButton && !cartDrawer.busy) {
        const group = cartDrawer.groups.find((candidate) => candidate.id === quantityButton.dataset.bskCartQuantity);
        const quantity = Math.max(0, group.quantity + Number(quantityButton.dataset.delta || 0));
        await postCartUpdate(quantityUpdatesForGroup(group, quantity));
        return;
      }
      const remove = event.target.closest('[data-bsk-cart-remove]');
      if (remove && !cartDrawer.busy) {
        const group = cartDrawer.groups.find((candidate) => candidate.id === remove.dataset.bskCartRemove);
        await postCartUpdate(quantityUpdatesForGroup(group, 0));
        return;
      }
      if (event.target.closest('[data-bsk-cart-note-save]') && !cartDrawer.busy) {
        const note = root.querySelector('[data-bsk-cart-note]');
        setDrawerBusy(true);
        try {
          const response = await fetch(cartEndpoint('/update.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) });
          if (!response.ok) throw new Error('Not kaydedilemedi');
          const cart = await response.json();
          renderDrawerCart(await (window.BskSecondCupOffer?.syncCart(cart) || cart));
          announceDrawer('Sipariş notu kaydedildi.');
        } catch (_) { announceDrawer('Sipariş notu kaydedilemedi.'); }
        finally { setDrawerBusy(false); }
      }
    });
    root.addEventListener('keydown', (event) => {
      if (root.querySelector('dialog[open]')) return;
      if (event.key === 'Escape') {
        if (root.classList.contains('is-configuring')) closeSecondCup();
        else closeCartDrawer();
        return;
      }
      if (event.key !== 'Tab' || !root.classList.contains('is-open')) return;
      const focusable = Array.from(cartDrawer.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')).filter((element) => element.offsetParent !== null && !element.closest('[inert]'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-bsk-cart-trigger], a[href]');
      if (!trigger) return;
      let isCartLink = trigger.matches('[data-bsk-cart-trigger]');
      if (!isCartLink && trigger.matches('a[href]')) {
        try { isCartLink = new URL(trigger.href, window.location.href).pathname.replace(/\/$/, '') === cartEndpoint(); }
        catch (_) { isCartLink = false; }
      }
      if (!isCartLink) return;
      event.preventDefault();
      openCartDrawer(trigger);
    }, true);
    if (document.body.classList.contains('template-cart')) requestAnimationFrame(() => openCartDrawer(null));
  };
  initializeCartDrawer();
  const updateAddonTotal = (root) => {
    const summary = root.querySelector('[data-bsk-addon-summary]');
    const output = root.querySelector('[data-bsk-configured-total]');
    if (!summary || !output) return;
    const selected = Array.from(root.querySelectorAll('[data-bsk-addon-variant-id]:checked'));
    const addonTotal = selected.reduce((total, input) => total + Number(input.dataset.bskAddonPrice || 0), 0);
    const quantity = Math.max(1, Number.parseInt(root.querySelector('[data-bsk-quantity-input]')?.value, 10) || 1);
    const basePrice = Number(root.dataset.bskBasePrice || 0);
    const baseComparePrice = Number(root.dataset.bskBaseComparePrice || 0);
    const configuredTotal = (basePrice + addonTotal) * quantity;
    const configuredCompareTotal = ((baseComparePrice > basePrice ? baseComparePrice : basePrice) + addonTotal) * quantity;

    summary.hidden = false;
    output.textContent = formatMoney(configuredTotal, root.dataset.currency);
    root.querySelectorAll('[data-bsk-price]').forEach((node) => {
      node.textContent = formatMoney(configuredTotal, root.dataset.currency);
    });
    root.querySelectorAll('[data-bsk-compare-price]').forEach((node) => {
      const visible = configuredCompareTotal > configuredTotal;
      node.hidden = !visible;
      node.textContent = visible ? formatMoney(configuredCompareTotal, root.dataset.currency) : '';
    });
  };
  const updatePlateNameField = (root) => {
    const toggle = root.querySelector('[data-bsk-plate-name-toggle]');
    const field = root.querySelector('[data-bsk-plate-name-field]');
    const input = field && field.querySelector('input');
    if (!toggle || !field || !input) return;
    field.hidden = !toggle.checked;
    input.disabled = !toggle.checked;
    if (!toggle.checked) input.value = '';

    const delivery = root.querySelector('[data-bsk-delivery-card]');
    if (!delivery) return;
    const label = delivery.querySelector('[data-bsk-delivery-label]');
    const value = delivery.querySelector('[data-bsk-delivery-value]');
    const note = delivery.querySelector('[data-bsk-delivery-note]');
    if (toggle.checked) {
      if (label) label.textContent = toggle.dataset.bskPlateDeliveryLabel || 'Kişiselleştirme süresi';
      if (value) value.textContent = toggle.dataset.bskPlateDeliveryValue || 'Ek hazırlık gerekir';
      if (note) {
        note.textContent = toggle.dataset.bskPlateLeadTime || delivery.dataset.bskDefaultNote || '';
        note.hidden = !note.textContent;
      }
      return;
    }
    if (label) label.textContent = delivery.dataset.bskDefaultLabel || 'Gönderim durumu';
    if (value) value.textContent = delivery.dataset.bskDefaultValue || 'Stoktan gönderime hazır';
    if (note) {
      note.textContent = delivery.dataset.bskDefaultNote || '';
      note.hidden = !note.textContent;
    }
  };
  const updateLetterCtas = (root) => {
    const input = root.querySelector('[data-bsk-letter-input]');
    const requiresLetter = root.dataset.bskRequiresLetter === 'true';
    const needsLetter = requiresLetter && (!input || !input.value);
    const label = needsLetter
      ? (root.dataset.letterCtaLabel || 'Harf seç')
      : (root.dataset.addLabel || 'Sepete ekle');
    root.querySelectorAll('[data-bsk-add-button]').forEach((button) => {
      if (!button.disabled) button.textContent = label;
    });
  };
  const clearLetterSelection = (root) => {
    root.querySelectorAll('[data-bsk-letter]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
    root.querySelectorAll('[data-bsk-letter-output]').forEach((output) => { output.textContent = ''; });
    const status = root.querySelector('[data-bsk-letter-status]');
    if (status) status.textContent = 'harfi seçilmedi';
    const input = root.querySelector('[data-bsk-letter-input]');
    if (input) input.value = '';
    updateLetterCtas(root);
  };
  const updateProfileChoices = (root, changedInput) => {
    const charmGroup = root.querySelector('[data-bsk-charm-group]');
    if (charmGroup) {
      const max = Number(charmGroup.dataset.max || 0);
      let selected = Array.from(charmGroup.querySelectorAll('[data-bsk-charm-choice]:checked'));
      if (max > 0 && selected.length > max && changedInput?.matches('[data-bsk-charm-choice]')) {
        changedInput.checked = false;
        selected = Array.from(charmGroup.querySelectorAll('[data-bsk-charm-choice]:checked'));
      }
      const output = charmGroup.querySelector('[data-bsk-charm-output]');
      if (output) output.value = selected.map((input) => input.value).join(', ');
      const count = charmGroup.querySelector('[data-bsk-charm-count]');
      if (count) count.textContent = `${selected.length} / ${max} seçildi`;
      charmGroup.querySelectorAll('[data-bsk-charm-choice]:not(:checked)').forEach((input) => { input.disabled = max > 0 && selected.length >= max; });
      const needsLetter = selected.some((input) => input.value === 'Harf');
      const letterModule = root.querySelector('[data-bsk-letter-module]');
      if (root.dataset.bskLetterMode === 'conditional') {
        if (letterModule) letterModule.hidden = !needsLetter;
        root.dataset.bskRequiresLetter = String(needsLetter);
        if (!needsLetter) clearLetterSelection(root);
      }
    }

    const extraChoice = root.querySelector('[data-bsk-extra-choice]:checked');
    if (extraChoice && root.dataset.bskLetterMode === 'exclusive') {
      root.dataset.bskRequiresLetter = 'false';
      clearLetterSelection(root);
    } else if (root.dataset.bskLetterMode === 'exclusive') {
      root.dataset.bskRequiresLetter = 'true';
    }

    if (root.dataset.bskGiftMode === 'conditional') {
      const porcelainSelected = Boolean(root.querySelector('[data-bsk-porcelain-toggle]:checked'));
      root.querySelectorAll('[data-bsk-gift-premium]').forEach((card) => {
        const input = card.querySelector('input');
        card.hidden = !porcelainSelected;
        if (input) {
          if (!porcelainSelected && input.checked) {
            input.checked = false;
            const none = root.querySelector('.bsk-gift-package--none input');
            if (none) none.checked = true;
          }
          input.disabled = !porcelainSelected;
        }
      });
    }
    updateAddonTotal(root);
    updateLetterCtas(root);
  };
  const readProductProperties = (form) => {
    const properties = {};
    new FormData(form).forEach((value, name) => {
      if (!name.startsWith('properties[') || !name.endsWith(']') || value === '') return;
      const propertyName = name.slice(11, -1);
      properties[propertyName] = properties[propertyName] ? properties[propertyName] + ', ' + value : value;
    });
    return properties;
  };
  const addConfiguredProduct = async (form, root, addons) => {
    if (form.dataset.bskSubmitting === 'true' || form.dataset.bskPreparing === 'true') return;
    form.dataset.bskPreparing = 'true';
    let offerReady;
    try { offerReady = await window.BskOfferJourney?.prepareAdd(root); }
    finally { delete form.dataset.bskPreparing; }
    if (offerReady === false) return;
    const id = Number(root.querySelector('[data-bsk-variant-id]')?.value || 0);
    const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
    if (!id) return;
    const bundleId = (
      'B' +
      (
        typeof crypto.randomUUID === 'function'
          ? crypto.randomUUID().replace(/-/g, '').slice(0, 10)
          : (Date.now().toString(36) + Math.random().toString(36).slice(2, 7)).slice(-10)
      )
    ).toUpperCase();
    const properties = readProductProperties(form);
    properties._bsk_ref = bundleId;
    window.BskSecondCupOffer?.decorateProperties(properties, root);
    addons.forEach((addon) => {
      const propertyName = addon.dataset.bskAddonProperty;
      const label = addon.dataset.bskAddonLabel;
      if (!propertyName || !label) return;
      properties[propertyName] = properties[propertyName] ? properties[propertyName] + ', ' + label : label;
    });
    const parentTitle = root.querySelector('.bsk-product__purchase h1')?.textContent.trim() || '';
    const items = [{ id, quantity, properties }].concat(addons.map((addon) => ({
      id: Number(addon.dataset.bskAddonVariantId),
      quantity,
      properties: {
        _bsk_ref: `${bundleId}:A`
      }
    })));
    const buttons = Array.from(root.querySelectorAll('[data-bsk-add-button]'));
    const secondCup = root.hasAttribute('data-bsk-second-product');
    const offerCup = root.hasAttribute('data-bsk-offer-product');
    form.dataset.bskSubmitting = 'true';
    if (secondCup) form.inert = true;
    if (offerCup) window.BskSecondCupOffer?.setSubmitting(true);
    buttons.forEach((button) => { button.disabled = true; button.textContent = 'Ekleniyor…'; });
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) {
        const error = new Error(response.status === 422 ? 'Bu fincandan ikinci adet şu an eklenemiyor. Seçeneklerini kontrol et veya sepetine geç.' : 'Sepete ekleme başarısız');
        throw error;
      }
      await response.json();
      form.dataset.bskSubmitting = 'false';
      if (secondCup) {
        closeSecondCup(false);
        if (offerCup) { await window.BskSecondCupOffer?.complete(); return; }
        const cart = await loadDrawerCart();
        announceDrawer(cart ? 'Yeni fincan seçtiğin harfle sepete eklendi. İlk fincanın değişmedi.' : 'Fincan eklendi. Sepeti görmek için tekrar yükle.');
        if (drawerElements()?.classList.contains('is-open')) drawerElements().querySelector('[data-bsk-cart-close]')?.focus();
        return;
      }
      buttons.forEach((button) => { button.disabled = false; button.textContent = root.dataset.addLabel || 'Sepete ekle'; });
      updateLetterCtas(root);
      if (await window.BskSecondCupOffer?.afterAdd({ ...secondCupOfferContext(), bundleId, offerAdded: Boolean(properties._bsk_offer), opener: buttons[0] || null })) return;
      await openCartDrawer(buttons[0] || null);
    } catch (error) {
      form.dataset.bskSubmitting = 'false';
      if (secondCup) form.inert = false;
      if (offerCup) window.BskSecondCupOffer?.setSubmitting(false, error.message);
      buttons.forEach((button) => { button.disabled = false; button.textContent = root.dataset.addLabel || 'Sepete ekle'; });
      updateLetterCtas(root);
      root.querySelectorAll('[data-bsk-product-message]').forEach((message) => { message.textContent = 'Seçenekler sepete eklenemedi. Lütfen tekrar deneyin.'; });
    }
  };
  const updateProductVariant = (root) => {
    const data = root.querySelector('[data-bsk-product-variants]');
    if (!data) return;
    let variants = [];
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    const selected = Array.from(root.querySelectorAll('[data-bsk-option]')).sort((a,b) => Number(a.dataset.bskOptionPosition)-Number(b.dataset.bskOptionPosition)).map(select => select.value);
    const variant = variants.find(item => item.options.every((value,index) => value === selected[index])) || (selected.length === 0 ? variants[0] : null);
    const idInput = root.querySelector('[data-bsk-variant-id]');
    const buttons = root.querySelectorAll('[data-bsk-add-button]');
    const addLabel = root.dataset.addLabel || 'Sepete ekle';
    const soldOutLabel = root.dataset.soldOutLabel || 'Tükendi';
    const unavailableLabel = root.dataset.unavailableLabel || 'Bu seçenek kullanılamıyor';
    if (!variant) {
      if (idInput) idInput.value = '';
      buttons.forEach(button => { button.disabled = true; button.textContent = unavailableLabel; });
      return;
    }
    if (idInput) idInput.value = variant.id;
    root.dataset.bskBasePrice = String(variant.price);
    root.dataset.bskBaseComparePrice = String(variant.compare_at_price || 0);
    buttons.forEach(button => { button.disabled = !variant.available; button.textContent = variant.available ? addLabel : soldOutLabel; });
    updateLetterCtas(root);
    updateAddonTotal(root);
    if (!root.hasAttribute('data-bsk-second-product') && history.replaceState) history.replaceState({}, '', location.pathname + '?variant=' + variant.id + location.hash);
  };
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-bsk-option]')) return;
    const root = event.target.closest('[data-bsk-product]');
    if (root) updateProductVariant(root);
  });
  document.addEventListener('change', (event) => {
    const root = event.target.closest('[data-bsk-product]');
    if (!root) return;
    if (event.target.matches('[data-bsk-letter-input]')) updateLetterCtas(root);
    if (event.target.matches('[data-bsk-plate-name-toggle]')) updatePlateNameField(root);
    if (event.target.matches('[data-bsk-charm-choice], [data-bsk-extra-choice], [data-bsk-porcelain-toggle]')) updateProfileChoices(root, event.target);
    if (event.target.matches('[data-bsk-addon-choice], [data-bsk-quantity-input]')) updateAddonTotal(root);
  });
  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-bsk-add-button]');
    if (addButton && !addButton.disabled) {
      const root = addButton.closest('[data-bsk-product]');
      const input = root?.querySelector('[data-bsk-letter-input]');
      if (root?.dataset.bskRequiresLetter === 'true' && (!input || !input.value)) {
        event.preventDefault();
        const letterModule = root.querySelector('[data-bsk-letter-module]');
        letterModule?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => root.querySelector('[data-bsk-letter]')?.focus({ preventScroll: true }), 350);
        root.querySelectorAll('[data-bsk-product-message]').forEach((message) => {
          message.textContent = 'Devam etmek için harfinizi seçin.';
        });
        return;
      }
    }
    const plateExampleOpen = event.target.closest('[data-bsk-plate-example-open]');
    if (plateExampleOpen) {
      const dialogId = plateExampleOpen.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (dialog?.showModal) {
        const deferredImage = dialog.querySelector('[data-bsk-plate-example-image][data-src]');
        if (deferredImage) {
          deferredImage.src = deferredImage.dataset.src;
          deferredImage.removeAttribute('data-src');
        }
        dialog.__bskPlateExampleTrigger = plateExampleOpen;
        dialog.showModal();
      }
      return;
    }
    const plateExampleClose = event.target.closest('[data-bsk-plate-example-close]');
    if (plateExampleClose) {
      const dialog = plateExampleClose.closest('[data-bsk-plate-example-dialog]');
      dialog?.close();
      dialog?.__bskPlateExampleTrigger?.focus();
      return;
    }
    if (event.target.matches('[data-bsk-plate-example-dialog]')) {
      const dialog = event.target;
      dialog.close();
      dialog.__bskPlateExampleTrigger?.focus();
      return;
    }
    const thumb = event.target.closest('[data-bsk-gallery-thumb]');
    if (thumb) {
      const root = thumb.closest('[data-bsk-product]');
      const index = thumb.dataset.bskGalleryThumb;
      root.querySelectorAll('[data-bsk-gallery-item]').forEach(item => { item.hidden = item.dataset.bskGalleryItem !== index; });
      root.querySelectorAll('[data-bsk-gallery-thumb]').forEach(item => item.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current','true');
      return;
    }
    const letter = event.target.closest('[data-bsk-letter]');
    if (letter) {
      const root = letter.closest('[data-bsk-product]');
      const value = letter.dataset.bskLetter || '';
      const extraChoice = root.querySelector('[data-bsk-extra-choice]:checked');
      if (extraChoice) extraChoice.checked = false;
      if (root.dataset.bskLetterMode === 'exclusive') root.dataset.bskRequiresLetter = 'true';
      root.querySelectorAll('[data-bsk-letter]').forEach(item => item.setAttribute('aria-pressed', String(item === letter)));
      root.querySelectorAll('[data-bsk-letter-output]').forEach(output => { output.textContent = value; });
      const status = root.querySelector('[data-bsk-letter-status]');
      if (status) status.textContent = ' harfi seçildi';
      const input = root.querySelector('[data-bsk-letter-input]');
      if (input) input.value = value;
      const position = Number(root.dataset.bskLetterOptionPosition || 0);
      if (position > 0) {
        const select = root.querySelector('[data-bsk-option-position="' + position + '"]');
        if (select) { select.value = value; updateProductVariant(root); }
      }
      root.querySelectorAll('[data-bsk-product-message]').forEach(message => { message.textContent = value + ' harfi seçildi.'; });
      updateLetterCtas(root);
    }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-bsk-product-form]');
    if (!form) return;
    const root = form.closest('[data-bsk-product]');
    const charmGroup = root && root.querySelector('[data-bsk-charm-group]');
    if (charmGroup) {
      const required = Number(charmGroup.dataset.min || 0);
      const selected = charmGroup.querySelectorAll('[data-bsk-charm-choice]:checked').length;
      if (selected !== required) {
        event.preventDefault();
        root.querySelectorAll('[data-bsk-product-message]').forEach((message) => { message.textContent = `Lütfen ${required} charm seçin.`; });
        charmGroup.querySelector('[data-bsk-charm-choice]:not([disabled])')?.focus();
        return;
      }
    }
    const input = root && root.querySelector('[data-bsk-letter-input]');
    if (root && root.dataset.bskRequiresLetter === 'true' && (!input || !input.value)) {
      event.preventDefault();
      root.querySelectorAll('[data-bsk-product-message]').forEach(message => { message.textContent = 'Lütfen 32 harften birini seçin.'; });
      const firstLetter = root.querySelector('[data-bsk-letter]');
      if (firstLetter) firstLetter.focus();
      return;
    }
    const addons = Array.from(form.querySelectorAll('[data-bsk-addon-variant-id]:checked'));
    event.preventDefault();
    addConfiguredProduct(form, root, addons);
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-bsk-quantity-input]')) {
      const root = event.target.closest('[data-bsk-product]');
      if (root) updateAddonTotal(root);
      return;
    }
    if (!event.target.matches('[data-bsk-bundle-quantity]')) return;
    const line = event.target.closest('[data-bsk-bundle-id]');
    const bundleId = line?.dataset.bskBundleId;
    if (!bundleId) return;
    const bundleLines = Array.from(document.querySelectorAll('[data-bsk-bundle-id="' + CSS.escape(bundleId) + '"]'));
    const parentQuantity = bundleLines.reduce((total, bundleLine) => {
      const input = bundleLine.querySelector('[data-bsk-bundle-quantity]');
      return total + (input ? Math.max(0, Number.parseInt(input.value, 10) || 0) : 0);
    }, 0);
    bundleLines.forEach((bundleLine) => {
      const addonQuantity = bundleLine.querySelector('[data-bsk-addon-quantity]');
      if (addonQuantity) addonQuantity.value = String(parentQuantity);
    });
  });
  document.addEventListener('click', async (event) => {
    const remove = event.target.closest('[data-bsk-remove-bundle]');
    if (!remove) return;
    event.preventDefault();
    const bundleId = remove.dataset.bskRemoveBundle;
    const updates = {};
    document.querySelectorAll('[data-bsk-bundle-id="' + CSS.escape(bundleId) + '"]').forEach((line) => { updates[line.dataset.bskCartLineKey] = 0; });
    remove.disabled = true;
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Sepet güncellenemedi');
      window.location.reload();
    } catch (_) {
      remove.disabled = false;
    }
  });
  document.querySelectorAll('[data-bsk-product]').forEach((root) => { updateProductVariant(root); updatePlateNameField(root); updateProfileChoices(root); updateAddonTotal(root); });
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-bsk-product]').forEach((root) => { updateProductVariant(root); updatePlateNameField(root); updateProfileChoices(root); updateAddonTotal(root); }));
  const initializeStickyBuyVisibility = (scope = document) => {
    scope.querySelectorAll('[data-bsk-product]').forEach((root) => {
      const sticky = root.querySelector('.bsk-sticky-buy');
      const mainButton = root.querySelector('.bsk-product__form .bsk-product__add[data-bsk-add-button]');
      if (!sticky || !mainButton || sticky.dataset.bskVisibilityReady === 'true') return;

      sticky.dataset.bskVisibilityReady = 'true';
      const controls = Array.from(sticky.querySelectorAll('a, button, input, select, textarea, [tabindex]'));
      let frame = 0;

      const update = () => {
        frame = 0;
        const headerBottom = Math.max(0, document.querySelector('.bsk-uheader')?.getBoundingClientRect().bottom || 0);
        const mainButtonRect = mainButton.getBoundingClientRect();
        const footer = document.querySelector('footer:not(.bsk-cdrawer__footer), [role="contentinfo"]');
        const footerTop = footer?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY;
        const hasPassedMainButton = mainButtonRect.bottom <= headerBottom + 8;
        const isBeforeFooter = footerTop > window.innerHeight;
        const isVisible = hasPassedMainButton && isBeforeFooter;

        sticky.classList.toggle('bsk-sticky-buy--visible', isVisible);
        sticky.setAttribute('aria-hidden', String(!isVisible));
        controls.forEach((control) => {
          if (!isVisible) {
            if (!control.hasAttribute('data-bsk-sticky-tabindex')) {
              control.setAttribute('data-bsk-sticky-tabindex', control.getAttribute('tabindex') ?? '');
            }
            control.setAttribute('tabindex', '-1');
            return;
          }
          const previousTabindex = control.getAttribute('data-bsk-sticky-tabindex');
          if (previousTabindex === '') control.removeAttribute('tabindex');
          else if (previousTabindex !== null) control.setAttribute('tabindex', previousTabindex);
          control.removeAttribute('data-bsk-sticky-tabindex');
        });
      };

      const requestUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      update();
    });
  };

  initializeStickyBuyVisibility();
  document.addEventListener('shopify:section:load', (event) => initializeStickyBuyVisibility(event.target));
})();

/* PDP swipe gallery with a visible next-image cue on all breakpoints. */
(function () {
  'use strict';

  var mobileGalleryQuery = '(max-width: 767px)';

  function initMobileSwipeGallery(root) {
    if (!root || root.dataset.bskSwipeGalleryInit === 'true') return;

    var track = root.querySelector('.bsk-product__main-media');
    var items = track ? Array.prototype.slice.call(track.querySelectorAll('[data-bsk-gallery-item]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-bsk-gallery-thumb]'));

    if (!track || items.length < 2) return;

    var mediaQuery = window.matchMedia(mobileGalleryQuery);
    var activeIndex = thumbs.findIndex(function (thumb) {
      return thumb.getAttribute('aria-current') === 'true';
    });
    var scrollFrame = 0;

    if (activeIndex < 0) activeIndex = 0;

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function centerTarget(index) {
      var item = items[index];
      return Math.max(0, item.offsetLeft);
    }

    function nearestItemIndex() {
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      items.forEach(function (item, index) {
        var distance = Math.abs(item.offsetLeft - track.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function centerThumb(index) {
      var thumb = thumbs[index];
      var thumbTrack = thumb && thumb.parentElement;
      if (!thumb || !thumbTrack || thumbTrack.scrollWidth <= thumbTrack.clientWidth) return;

      var target = thumb.offsetLeft - ((thumbTrack.clientWidth - thumb.offsetWidth) / 2);
      var maximum = thumbTrack.scrollWidth - thumbTrack.clientWidth;
      thumbTrack.scrollTo({
        left: Math.max(0, Math.min(maximum, target)),
        behavior: reducedMotion() ? 'auto' : 'smooth'
      });
    }

    function markActive(index, moveThumb) {
      activeIndex = Math.max(0, Math.min(items.length - 1, index));
      thumbs.forEach(function (thumb, thumbIndex) {
        if (thumbIndex === activeIndex) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (moveThumb) centerThumb(activeIndex);
    }

    function revealGalleryItems() {
      items.forEach(function (item) {
        item.hidden = false;
      });
    }

    function setMode() {
      window.cancelAnimationFrame(scrollFrame);

      revealGalleryItems();
      track.dataset.bskSwipeGallery = 'true';
      track.scrollLeft = centerTarget(activeIndex);
    }

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-bsk-gallery-thumb]');
      var index = thumbs.indexOf(thumb);
      if (!thumb || index < 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      revealGalleryItems();
      markActive(index, true);
      track.scrollTo({
        left: centerTarget(index),
        behavior: 'auto'
      });
    }, true);

    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        var nearestIndex = nearestItemIndex();
        if (nearestIndex !== activeIndex) markActive(nearestIndex, true);
      });
    }, { passive: true });

    var dragState = null;
    var suppressDraggedClick = false;

    function desktopDragEnabled() {
      return window.matchMedia('(min-width: 768px)').matches;
    }

    function finishDesktopDrag(event) {
      if (!dragState || (event && event.pointerId !== dragState.pointerId)) return;

      var wasDragging = dragState.dragging;
      var pointerId = dragState.pointerId;
      dragState = null;
      track.classList.remove('bsk-product__main-media--dragging');

      if (track.hasPointerCapture && track.hasPointerCapture(pointerId)) {
        track.releasePointerCapture(pointerId);
      }
      if (!wasDragging) return;

      var nearestIndex = nearestItemIndex();
      markActive(nearestIndex, true);
      track.scrollTo({
        left: centerTarget(nearestIndex),
        behavior: reducedMotion() ? 'auto' : 'smooth'
      });
      suppressDraggedClick = true;
    }

    track.addEventListener('pointerdown', function (event) {
      if (!desktopDragEnabled() || event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('video, iframe, model-viewer, button, a, input, select, textarea')) return;
      if (track.scrollWidth <= track.clientWidth) return;

      dragState = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startScrollLeft: track.scrollLeft,
        dragging: false
      };
      track.setPointerCapture(event.pointerId);
    });

    track.addEventListener('pointermove', function (event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      var distance = event.clientX - dragState.startX;
      if (!dragState.dragging && Math.abs(distance) < 6) return;

      dragState.dragging = true;
      track.classList.add('bsk-product__main-media--dragging');
      track.scrollLeft = dragState.startScrollLeft - distance;
      event.preventDefault();
    });

    track.addEventListener('pointerup', finishDesktopDrag);
    track.addEventListener('pointercancel', finishDesktopDrag);
    track.addEventListener('dragstart', function (event) {
      if (desktopDragEnabled()) event.preventDefault();
    });
    track.addEventListener('click', function (event) {
      if (!suppressDraggedClick) return;
      suppressDraggedClick = false;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', setMode);
    } else {
      mediaQuery.addListener(setMode);
    }

    root.dataset.bskSwipeGalleryInit = 'true';
    setMode();
  }

  function bootMobileSwipeGalleries(scope) {
    if (scope.matches && scope.matches('[data-bsk-product]')) initMobileSwipeGallery(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-bsk-product]'), initMobileSwipeGallery);
  }

  function boot() {
    bootMobileSwipeGalleries(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootMobileSwipeGalleries(event.target);
  });
}());

/*
 * A dismissed Klaviyo popup can occasionally leave its full-screen shell
 * active. Keep that invisible shell from intercepting storefront clicks while
 * preserving the popup whenever its form is actually visible.
 */
(function () {
  'use strict';

  var GUARDED_ATTRIBUTE = 'data-bsk-klaviyo-click-guard';
  var GUARD_STYLE_ID = 'bsk-klaviyo-click-guard-style';
  var PREVIOUS_VALUE_ATTRIBUTE = 'data-bsk-klaviyo-pointer-value';
  var PREVIOUS_PRIORITY_ATTRIBUTE = 'data-bsk-klaviyo-pointer-priority';
  var SIGNAL_SELECTOR = '.klaviyo-form, .klaviyo-close-form';
  var knownRoots = [];
  var auditFrame = 0;
  var observer;

  function ensureGuardStyles() {
    var style;

    if (document.getElementById(GUARD_STYLE_ID)) return;

    style = document.createElement('style');
    style.id = GUARD_STYLE_ID;
    style.textContent =
      '[' + GUARDED_ATTRIBUTE + '],[' + GUARDED_ATTRIBUTE + '] *{pointer-events:none!important;}';
    document.head.appendChild(style);
  }

  function addRoot(root) {
    if (!root || root === document.documentElement || knownRoots.indexOf(root) !== -1) return;
    knownRoots.push(root);
  }

  function collectRootsFrom(element) {
    var node = element;

    while (node && node !== document.documentElement) {
      if (node.nodeType === 1 && window.getComputedStyle(node).position === 'fixed') {
        addRoot(node);
      }
      node = node.parentElement;
    }
  }

  function discoverRoots(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var signals = root.querySelectorAll(SIGNAL_SELECTOR);

    if (root.nodeType === 1 && root.matches(SIGNAL_SELECTOR)) {
      collectRootsFrom(root);
    }

    Array.prototype.forEach.call(signals, collectRootsFrom);
  }

  function isVisuallyPresent(element, boundary) {
    var rect = element.getBoundingClientRect();
    var node = element;

    if (rect.width <= 1 || rect.height <= 1) return false;
    if (rect.right <= 0 || rect.bottom <= 0 || rect.left >= window.innerWidth || rect.top >= window.innerHeight) {
      return false;
    }

    while (node && node !== document.documentElement) {
      var style = window.getComputedStyle(node);
      var opacity = parseFloat(style.opacity);

      if (
        node.hidden ||
        node.getAttribute('aria-hidden') === 'true' ||
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        style.visibility === 'collapse' ||
        (!isNaN(opacity) && opacity <= 0.01)
      ) {
        return false;
      }

      if (node === boundary) break;
      node = node.parentElement;
    }

    return true;
  }

  function hasVisibleForm(root) {
    var forms = [];

    if (root.matches('.klaviyo-form')) forms.push(root);
    forms = forms.concat(Array.prototype.slice.call(root.querySelectorAll('.klaviyo-form')));

    return forms.some(function (form) {
      return isVisuallyPresent(form, root);
    });
  }

  function coversViewport(root) {
    var rect = root.getBoundingClientRect();
    return rect.width >= window.innerWidth * 0.75 && rect.height >= window.innerHeight * 0.75;
  }

  function guardRoot(root) {
    if (!root.hasAttribute(GUARDED_ATTRIBUTE)) {
      root.setAttribute(PREVIOUS_VALUE_ATTRIBUTE, root.style.getPropertyValue('pointer-events'));
      root.setAttribute(PREVIOUS_PRIORITY_ATTRIBUTE, root.style.getPropertyPriority('pointer-events'));
      root.setAttribute(GUARDED_ATTRIBUTE, 'true');
    }

    if (
      root.style.getPropertyValue('pointer-events') !== 'none' ||
      root.style.getPropertyPriority('pointer-events') !== 'important'
    ) {
      root.style.setProperty('pointer-events', 'none', 'important');
    }
  }

  function restoreRoot(root) {
    var previousValue;
    var previousPriority;

    if (!root.hasAttribute(GUARDED_ATTRIBUTE)) return;

    previousValue = root.getAttribute(PREVIOUS_VALUE_ATTRIBUTE) || '';
    previousPriority = root.getAttribute(PREVIOUS_PRIORITY_ATTRIBUTE) || '';

    if (previousValue) {
      root.style.setProperty('pointer-events', previousValue, previousPriority);
    } else {
      root.style.removeProperty('pointer-events');
    }

    root.removeAttribute(GUARDED_ATTRIBUTE);
    root.removeAttribute(PREVIOUS_VALUE_ATTRIBUTE);
    root.removeAttribute(PREVIOUS_PRIORITY_ATTRIBUTE);
  }

  function auditRoots() {
    auditFrame = 0;
    discoverRoots(document);

    knownRoots = knownRoots.filter(function (root) {
      if (!document.documentElement.contains(root)) return false;

      if (hasVisibleForm(root) || !coversViewport(root)) {
        restoreRoot(root);
      } else {
        guardRoot(root);
      }

      return true;
    });

    if (!knownRoots.some(hasVisibleForm)) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
    }
  }

  function scheduleAudit(delay) {
    if (delay) {
      window.setTimeout(function () {
        scheduleAudit();
      }, delay);
      return;
    }

    if (auditFrame) return;
    auditFrame = window.requestAnimationFrame(auditRoots);
  }

  function scheduleCloseAudits() {
    scheduleAudit();
    scheduleAudit(150);
    scheduleAudit(400);
    scheduleAudit(900);
    scheduleAudit(1600);
  }

  function scheduleOpenAudits() {
    scheduleAudit();
    scheduleAudit(100);
    scheduleAudit(300);
    scheduleAudit(700);
  }

  function nodeTouchesKlaviyo(node, includeDescendants) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches(SIGNAL_SELECTOR) || node.closest(SIGNAL_SELECTOR)) return true;
    return includeDescendants && Boolean(node.querySelector(SIGNAL_SELECTOR));
  }

  function mutationTouchesKlaviyo(mutation) {
    var index;

    if (mutation.type === 'attributes') {
      return nodeTouchesKlaviyo(mutation.target, true);
    }

    if (nodeTouchesKlaviyo(mutation.target, false)) return true;

    for (index = 0; index < mutation.addedNodes.length; index += 1) {
      if (nodeTouchesKlaviyo(mutation.addedNodes[index], true)) return true;
    }

    for (index = 0; index < mutation.removedNodes.length; index += 1) {
      if (nodeTouchesKlaviyo(mutation.removedNodes[index], true)) return true;
    }

    return false;
  }

  function bootKlaviyoClickGuard() {
    ensureGuardStyles();
    discoverRoots(document);
    scheduleAudit();

    observer = new MutationObserver(function (mutations) {
      if (mutations.some(mutationTouchesKlaviyo)) scheduleAudit();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'style'],
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest && event.target.closest('.klaviyo-close-form');

    if (!closeButton) return;
    collectRootsFrom(closeButton);
    scheduleCloseAudits();
  }, true);

  window.addEventListener('klaviyoForms', function (event) {
    var type = event.detail && event.detail.type;

    if (type === 'close' || type === 'submit') {
      scheduleCloseAudits();
    } else {
      scheduleOpenAudits();
    }
  });

  window.addEventListener('pageshow', function () {
    scheduleAudit();
  });

  window.addEventListener('resize', function () {
    scheduleAudit();
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleAudit();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootKlaviyoClickGuard, { once: true });
  } else {
    bootKlaviyoClickGuard();
  }
}());
